<div class="infobox {{ displayType }}">
	<table style="width: 100%">
		<tr>
			@if (includeIcon) {
				<td class="icon" rowspan="2">
					<mat-icon [svgIcon]="icon" class="icon-color"></mat-icon>
				</td>
			}
			<td class="header" [innerHtml]="header | safe: 'html'"></td>
		</tr>
		<tr>
			@if (!!body) {
				<td class="body" [innerHtml]="body | safe: 'html'"></td>
			}
		</tr>
	</table>
</div>
